"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const styles_1 = require("../styles");
const TextBase = ({ children, color = 'default', style, size = 1, weight = 'regular', ...nativeTextProps }) => (react_1.default.createElement(react_native_1.Text, Object.assign({ style: react_native_1.StyleSheet.flatten([
        styles.textBase,
        colorStyles[color],
        weightStyles[weight],
        { fontSize: styles_1.getFontSize(size), lineHeight: styles_1.getFontSize(size) + 8 },
        style,
    ]) }, nativeTextProps, { children: children })));
exports.default = TextBase;
const styles = react_native_1.StyleSheet.create({
    textBase: {
        writingDirection: 'rtl',
    },
});
const weightStyles = react_native_1.StyleSheet.create({
    regular: {
        fontFamily: 'IranYekan-FD-Regular',
    },
    medium: {
        fontFamily: 'IranYekan-FD-Medium',
    },
    bold: {
        fontFamily: 'IranYekan-FD-Bold',
    },
});
const colorStyles = react_native_1.StyleSheet.create({
    default: {
        color: styles_1.Colors.black,
    },
    primary: {
        color: styles_1.Colors.primary,
    },
    secondary: {
        color: styles_1.Colors.secondary,
    },
    white: {
        color: styles_1.Colors.white,
    },
    description: {
        color: styles_1.Colors.description,
    },
    error: {
        color: styles_1.Colors.error,
    },
    disabled: {
        color: styles_1.Colors.darkGray,
    },
    success: {
        color: styles_1.Colors.green,
    },
});
